import LeadsProvider from '../../components/leads-provider';
import PreSignUpPage from './pre-signup-page';

const PreSignup = () => {
  return (
    <LeadsProvider>
      <PreSignUpPage />
    </LeadsProvider>
  );
};

export default PreSignup;
